import { gql } from '@lcs/shared/api';

export const getAccountQueueMembersQuery = gql`
   query GetAccountQueueMembers($first: Int!, $filters: String) {
      extensionsConnection(first: $first, filters: $filters) {
         items {
            extensionId
            name
            number
            shortName
            extensionQueue {
               extensionQueueId
               queueMembersConnection {
                  items {
                     queueMemberId
                     isLoggedIn
                     agentStatus
                     endWrapUpTime
                     agentExtension {
                        extensionId
                        name
                        number
                     }
                  }
               }
            }
         }
      }
   }
`;
